// toast.service.ts
import { Injectable, inject } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef } from '@angular/core';
import { ToastComponent } from '@components/admin/configurator/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  
  private overlay = inject(Overlay);

  async show(message: string, type: 'success' | 'error' | 'info' = 'info', duration = 1500) {
    const overlayRef = this.createOverlay();
    const toastPortal = new ComponentPortal(ToastComponent);
    const toastRef: ComponentRef<ToastComponent> = overlayRef.attach(toastPortal);

    toastRef.instance.message = message;
    toastRef.instance.type = type;
    toastRef.instance.show();

    setTimeout(async () => {
      await toastRef.instance.hide();
      toastRef.destroy();
      overlayRef.dispose();
    }, duration);
  }

  private createOverlay(): OverlayRef {
    return this.overlay.create({
      positionStrategy: this.overlay.position()
        .global()
        .top('90px')
        .right('20px'),
      hasBackdrop: false,
      panelClass: ['pointer-events-none', 'z-50'],
      scrollStrategy: this.overlay.scrollStrategies.noop()
    });
  }
}
